import React, { useEffect, useState } from "react";
import Main from "../../../layout/main/Main";
import { get_market_orders_dapper } from "../../../../api/endpoints/orders";
import { Button, DatePicker, Input, Select, Spin } from "antd";
import {
	AntdInput,
	CompaginationDiv,
	FilterActions,
	FilterCard,
	FilterContainer,
	PageTitle,
	PageWrapper,
	PrimaryButton,
	SecondaryButton,
	TableWrapper,
} from "./styles";
import OrdersTable from "./components/orders-table/OrdersTable";
import { useFilter } from "../../../../contexts/filterContext";
import { CONSTANTS } from "../../../../utils/constants";
import moment from "moment";
import {
	LeftOutlined,
	RightOutlined,
	SearchOutlined,
	FilterOutlined,
} from "@ant-design/icons";
import { useAuth } from "../../../../contexts/authContext";
import { Link } from "react-router-dom";

export default function MarketOrders({ clientId }) {
	const {
		marketOrdersLaboratoryId,
		setMarketOrdersLaboratoryId,
		marketOrdersDistributorId,
		setMarketOrdersDistributorId,
		marketOrdersPharmacyId,
		setMarketOrdersPharmacyId,
		marketOrdersSellerId,
		setMarketOrdersSellerId,
		marketOrdersProvinceName,
		setMarketOrdersProvinceName,
		marketOrdersTypeOfSale,
		setMarketOrdersTypeOfSale,
		marketOrdersOrderState,
		setMarketOrdersOrderState,
		marketOrdersOrdersFrom,
		setMarketOrdersOrdersFrom,
		marketOrdersOrdersTo,
		setMarketOrdersOrdersTo,
		marketOrdersOrdersRange,
		setMarketOrdersOrdersRange,
		userSellerId,
	} = useFilter();

	const { ordersQty, setOrdersQty } = useAuth();

	const [data, setData] = useState(null);
	const [searchInfo, setSearchInfo] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [page, setPage] = useState(CONSTANTS.PAGE_LARGE_SIZE);
	const [paginationInputValue, setPaginationInputValue] = useState(null);
	const [pharmacies, setPharmacies] = useState(null);
	const [distributors, setDistributors] = useState(null);
	const [users, setUsers] = useState(null);
	const [provinces, setProvinces] = useState(null);
	const [orderTypes, setOrderTypes] = useState(null);
	const [orderStates, setOrderStates] = useState(null);
	const [orderSearch, setOrderSearch] = useState("");

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const selectStateToShow = (state) => {
		switch (state) {
			case CONSTANTS.ORDER_STATE_PENDING:
				return "Pendientes";
			case CONSTANTS.ORDER_STATE_ACTIVE:
				return "Activas";
			case CONSTANTS.ORDER_STATE_SENDED:
				return "Enviadas";
			case CONSTANTS.ORDER_STATE_CANCELED:
				return "Canceladas";
			default:
				return state;
		}
	};

	const fetch_orders = async (skipValue) => {
		setIsLoading(true);
		try {
			const res = await get_market_orders_dapper(
				marketOrdersLaboratoryId,
				marketOrdersDistributorId,
				marketOrdersPharmacyId,
				userSellerId ?? marketOrdersSellerId,
				marketOrdersProvinceName,
				marketOrdersTypeOfSale,
				marketOrdersOrderState,
				marketOrdersOrdersFrom,
				marketOrdersOrdersTo,
				skipValue,
				page,
			);

			const resTypesOfOrders = JSON.parse(res?.paginationInfo?.typesOfOrders);
			const resStatesOfOrders = JSON.parse(res?.paginationInfo?.statesOfOrders);
			const resProvinceOfOrders = JSON.parse(
				res?.paginationInfo?.provinceOfOrders,
			);
			const resPharmacyOfOrders = JSON.parse(
				res?.paginationInfo?.pharmacyOfOrders,
			);

			setData(res?.orders);
			setSearchInfo(res?.paginationInfo);
			setPaginationInputValue(res?.paginationInfo?.actualPage?.toString());

			setUsers(
				res?.users?.map((r) => ({
					value: r.sellerId,
					label: r.sellerFirstName + " " + r.sellerLastName,
				})),
			);

			setOrderTypes(
				resTypesOfOrders?.map((r) => ({
					value: r.TypeOfSale,
					label: r.TypeOfSale,
				})),
			);

			setOrderStates(
				resStatesOfOrders?.map((r) => ({
					value: r.OrderState,
					label: selectStateToShow(r.OrderState),
				})),
			);

			setProvinces(
				resProvinceOfOrders?.map((r) => ({
					value: r.ProvinceName,
					label: r.ProvinceName,
				})),
			);

			setPharmacies(
				resPharmacyOfOrders?.map((r) => ({
					value: r.PharmacyId,
					label: r.PharmacyName,
				})),
			);

			setDistributors(
				res?.distributors?.map((r) => ({
					value: r.distributorId,
					label: r.distributorName,
				})),
			);

			if (res && res?.paginationInfo.totalActive !== ordersQty) {
				setOrdersQty(res?.paginationInfo.totalActive);
			}
		} catch (err) {
			console.log(err);
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		setPage(CONSTANTS.PAGE_LARGE_SIZE);
		fetch_orders(1);
	}, [
		marketOrdersLaboratoryId,
		marketOrdersDistributorId,
		marketOrdersPharmacyId,
		marketOrdersSellerId,
		marketOrdersProvinceName,
		marketOrdersTypeOfSale,
		marketOrdersOrderState,
		marketOrdersOrdersFrom,
		marketOrdersOrdersTo,
	]);

	const handleDeleteFilters = () => {
		setMarketOrdersLaboratoryId(null);
		setMarketOrdersDistributorId(null);
		setMarketOrdersPharmacyId(null);
		setMarketOrdersSellerId(null);
		setMarketOrdersProvinceName(null);
		setMarketOrdersTypeOfSale(null);
		setMarketOrdersOrderState(null);
		setMarketOrdersOrdersFrom(null);
		setMarketOrdersOrdersTo(null);
		setMarketOrdersOrdersRange(null);
		setOrderSearch("");
	};

	const handleDecrement = () => {
		if (searchInfo.actualPage > 1) {
			const cp = searchInfo.actualPage - 1;
			fetch_orders(cp);
		}
	};

	const handleIncrement = () => {
		if (searchInfo.actualPage < searchInfo.totalPages) {
			const cp = searchInfo.actualPage + 1;
			fetch_orders(cp);
		}
	};

	const handlePageChange = (e) => {
		const selectedPage = parseInt(e.target.value);
		if (
			!isNaN(selectedPage) &&
			selectedPage >= 1 &&
			selectedPage <= searchInfo.totalPages
		) {
			fetch_orders(selectedPage);
			setPaginationInputValue(selectedPage);
		} else {
			setPaginationInputValue(searchInfo.actualPage);
		}
	};

	const handleSelectedDate = (dateRange) => {
		if (!dateRange || !dateRange[0] || !dateRange[1]) {
			setMarketOrdersOrdersFrom(null);
			setMarketOrdersOrdersTo(null);
			setMarketOrdersOrdersRange(null);
			return;
		}

		const firstDate = moment(dateRange[0]).format("MM-DD-YYYY").toString();
		const lastDate = moment(dateRange[1]).format("MM-DD-YYYY").toString();
		setMarketOrdersOrdersFrom(firstDate);
		setMarketOrdersOrdersTo(lastDate);
		setMarketOrdersOrdersRange([dateRange[0], dateRange[1]]);
	};

	const selectDistributor = (e) => setMarketOrdersDistributorId(e);
	const selectPharmacy = (e) => setMarketOrdersPharmacyId(e);
	const selectProvince = (e) => setMarketOrdersProvinceName(e);
	const selectTypeOfSale = (e) => setMarketOrdersTypeOfSale(e);
	const selectState = (e) => setMarketOrdersOrderState(e);

	return (
		<Main>
			<Main.Header>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						<Link to="/">Home</Link>
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>Ordenes</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>

			<Main.Body>
				<PageWrapper>
					<PageTitle>Gestión de Pedidos</PageTitle>

					<FilterCard>
						{data ? (
							<FilterContainer>
								<DatePicker.RangePicker
									format="DD/MM/YYYY"
									value={marketOrdersOrdersRange || null}
									onChange={(e) => handleSelectedDate(e)}
								/>

								<Select
									showSearch
									allowClear
									placeholder="Droguería"
									value={marketOrdersDistributorId}
									optionFilterProp="children"
									onChange={(e) => selectDistributor(e)}
									filterOption={(input, option) =>
										(option?.label ?? "")
											.toLowerCase()
											.includes(input.toLowerCase())
									}
									options={distributors}
									style={{ width: 270 }}
								/>

								<Select
									showSearch
									allowClear
									placeholder="Farmacia"
									value={marketOrdersPharmacyId}
									optionFilterProp="children"
									onChange={(e) => selectPharmacy(e)}
									filterOption={(input, option) =>
										(option?.label ?? "")
											.toLowerCase()
											.includes(input.toLowerCase())
									}
									options={pharmacies}
									style={{ width: 180 }}
								/>

								<Select
									showSearch
									allowClear
									placeholder="Provincia"
									optionFilterProp="children"
									value={marketOrdersProvinceName}
									onChange={(e) => selectProvince(e)}
									filterOption={(input, option) =>
										(option?.label ?? "")
											.toLowerCase()
											.includes(input.toLowerCase())
									}
									options={provinces}
									style={{ width: 180 }}
								/>

								{/* <Select
									showSearch
									allowClear
									placeholder="Estado"
									optionFilterProp="children"
									value={marketOrdersOrderState}
									onChange={(e) => selectState(e)}
									filterOption={(input, option) =>
										(option?.label ?? "")
											.toLowerCase()
											.includes(input.toLowerCase())
									}
									options={orderStates}
									style={{ width: 200 }}
								/> */}

								<FilterActions>
									<PrimaryButton
										onClick={handleDeleteFilters}
										loading={isLoading}
									>
										Limpiar filtros
									</PrimaryButton>
								</FilterActions>
							</FilterContainer>
						) : (
							<FilterContainer>
								<Spin />
							</FilterContainer>
						)}
					</FilterCard>

					<TableWrapper>
						<OrdersTable data={data} loading={isLoading} clientId={clientId} />
					</TableWrapper>

					{searchInfo && searchInfo.totalOrders > 0 && (
						<CompaginationDiv>
							{searchInfo.actualPage !== 1 && (
								<Button size="small" shape="circle" onClick={handleDecrement}>
									<LeftOutlined />
								</Button>
							)}

							<AntdInput
								step={1}
								min={1}
								max={searchInfo.totalPages}
								onPressEnter={(e) => handlePageChange(e)}
								onChange={(e) =>
									setPaginationInputValue(e.target.value.toString())
								}
								value={(paginationInputValue || 1).toString()}
								addonAfter={`/ ${searchInfo.totalPages}`}
								style={{
									width: `${searchInfo.totalPages > 99 ? "82px" : "72px"}`,
								}}
							/>

							{searchInfo.actualPage < searchInfo.totalPages && (
								<Button
									size="small"
									shape="circle"
									onClick={handleIncrement}
									disabled={searchInfo.actualPage === searchInfo.totalPages}
								>
									<RightOutlined />
								</Button>
							)}
						</CompaginationDiv>
					)}
				</PageWrapper>
			</Main.Body>
		</Main>
	);
}
